import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getDigiKycRespUrl } from "../utils/urlHelper";

const digiKycRespApi = createApi({
  reducerPath: "digiKycResp",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    digiKycResp: builder.mutation({
      query: (body) => ({
        url: getDigiKycRespUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useDigiKycRespMutation } = digiKycRespApi;
export { digiKycRespApi };
